module.exports = __webpack_public_path__ + "img/10_104.4635f18d.png";